import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { getFiltersService } from '../../services/get-filters.service';
import { FilterSelectedValue } from './interfaces/filter-selected-value.interface';
import { Filter } from './interfaces/filter.interface';
export const FILTERS = 'filters/REACT_QUERY_KEY';
export interface AppFilters {
  filters: Filter[] | undefined;
  error: Error | null;
  //isFetching:boolean
}

export const useAppFilters = (filterSelection: FilterSelectedValue[]) => {
  const { data: filters, error } = useQuery({
    queryKey: [FILTERS],
    queryFn: () => getFiltersService(filterSelection),
    placeholderData: keepPreviousData,
    throwOnError: true,
  });

  const value = useMemo((): AppFilters => {
    return { filters, error };
  }, [filters, error]);
  return value;
};

export const useAppFindFilter = (
  filters: Filter[] | undefined,
  filterId: string,
) => {
  const filter = useMemo(() => {
    return filters?.find((i) => i.id === filterId);
  }, [filters, filterId]);

  return filter;
};

export const useAppFindFilters = (
  filters: Filter[] | undefined,
  filterIds: string[],
) => {
  const foundFilters = useMemo(() => {
    return filters
      ?.filter((i) => filterIds.find((j) => j === i.id))
      .sort((a, b) => a.order - b.order);
  }, [filters, filterIds]);

  return foundFilters;
};

export const useAppFindFiltersF = (
  filters: Filter[] | undefined,
  findFunc: (sel: Filter) => boolean,
) => {
  const foundFilters = useMemo(() => {
    return filters?.filter(findFunc).sort((a, b) => a.order - b.order);
  }, [filters, findFunc]);

  return foundFilters;
};
export const useAppFilterDict = (filters: Filter[] | undefined) => {
  const filterDict: Record<string, Filter> = useMemo(() => {
    const dict: Record<string, Filter> = {};
    if (filters) {
      for (let i = 0; i < filters.length; i++) {
        const filter = filters[i];
        dict[filter.id] = filter;
      }
    }
    return dict;
  }, [filters]);
  return filterDict;
};
